import jwtInterceptor from "./jwtInterceptor";
import { FAOS_ENDPOINTS } from "../utils/api";

class FaosService {
    search(body) {
        return jwtInterceptor.post(FAOS_ENDPOINTS.search, body).then((response) => {
            return response.data;
        });
    }

    findByLandId(landId) {
        return jwtInterceptor.get(FAOS_ENDPOINTS.findByLandId.replace(":landId", landId)).then((response) => {
            return response.data;
        });
    }
}

export const faosService = new FaosService(); 